import PropTypes from 'prop-types'
import styled from 'styled-components/macro'

import { Tag } from '@loadsmart/loadsmart-ui'
import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

import { I18n } from 'legacy/components/I18n/i18n'
import { REQUIREMENTS } from 'legacy/constants/requirements'
import { LoadFeatures } from 'legacy/containers/LoadsPage/constants/LoadOffer'
import { screen } from 'legacy/styles/screen'
import { getStopInfo } from 'legacy/utils/getStopInfo'

import { Mileage } from './Mileage'

const Wrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  align-items: center;

  color: ${getToken('color-neutral-darkest')};
  font-weight: bold;
  font-size: 16px;
`

const City = styled.span`
  position: relative;

  display: inline-flex;

  line-height: 24px;
  text-transform: capitalize;

  margin-right: 8px;
  margin-bottom: 10px;

  ${screen.md} {
    margin-bottom: 0px;
  }
`

const LabelTag = styled(Tag)`
  margin-right: 0.5rem;
  margin-bottom: 10px;

  ${screen.md} {
    margin-bottom: 0px;
  }
`

const FastTag = styled(Tag)`
  display: none;
  margin-right: 4px;

  ${screen.md} {
    display: inline-flex;
  }
`

const DropTrailerTag = styled(Tag)`
  display: inline-flex;
  margin-bottom: 10px;

  ${screen.md} {
    margin-bottom: 0px;
  }
`

function Location(props) {
  const { location, mileage, showTag, showMileage, hideFastFacility, showDropTrailer, ...rest } =
    props
  const { pickupDeliveryLabel } = getStopInfo({ stop: location })
  const { city, state, tags = [] } = location

  const isFastFacility = tags.includes(LoadFeatures.FastFacility)
  const isTopRatedFacility = tags.includes(LoadFeatures.TopRatedFacility)
  const showFasFacility = isFastFacility && !hideFastFacility
  const cityLabel = `${city?.toLowerCase()}, ${state?.toUpperCase()}`

  return (
    <Wrapper {...rest}>
      {showTag && (
        <LabelTag size="default" variant="default">
          {pickupDeliveryLabel}
        </LabelTag>
      )}
      <City>{cityLabel}</City>
      {showFasFacility && (
        <FastTag size="small" variant="success">
          {I18n.get('lb.loadStop.features.fastFacility')}
        </FastTag>
      )}
      {isTopRatedFacility && (
        <FastTag size="small" variant="success">
          {I18n.get('lb.loadStop.features.topRatedFacility')}
        </FastTag>
      )}
      {showMileage && !!mileage && <Mileage mileage={mileage} />}
      {showDropTrailer && (
        <DropTrailerTag size="small" variant="warning">
          {REQUIREMENTS.drop_trailer.label}
        </DropTrailerTag>
      )}
    </Wrapper>
  )
}

Location.propTypes = {
  location: PropTypes.shape({
    city: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    zipcode: PropTypes.string,
    tags: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  showTag: PropTypes.bool,
  showMileage: PropTypes.bool,
  hideFastFacility: PropTypes.bool,
  mileage: PropTypes.string,
}

Location.defaultProps = {
  showTag: false,
  showMileage: false,
  hideFastFacility: false,
  mileage: '',
}

export { Location }
